import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'customer-details',
    templateUrl: './customer-details.component.html',
    styleUrls: ['./customer-details.component.scss'],
})
export class CustomerDetailsComponent implements OnInit {
    @Output() customerChange: EventEmitter<DocumentModel> = new EventEmitter();
    @Input() document: DocumentModel;
    display = false;
    buttonText = 'Show';

    constructor() {
    }

    ngOnInit() {
    }
}
